import React, { memo } from 'react'
import {
  Table,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
  Typography,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import styles from '../styles'

const CookieDetailsTable = ({ cookie }) => {
  const { t } = useTranslation()
  const classes = styles()

  if (!cookie) return null

  const noInfo = t('table.noInfo')

  let expirationDate = noInfo
  if (cookie?.expires) {
    try {
      expirationDate = new Date(cookie.expires * 1000).toLocaleDateString()
    } catch (_) {
      expirationDate = noInfo
    }
  }

  const rows = [
    { label: t('table.nameCol'), value: cookie?.name || noInfo },
    {
      label: t('table.hostCol'),
      value: cookie?.domain || noInfo,
    },
    { label: t('table.durationCol'), value: expirationDate },
    {
      label: t('table.typeCol'),
      value: cookie?.platform || noInfo,
    },
  ]

  return (
    <TableContainer>
      <Table size="small">
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.label}>
              <TableCell className={classes.tableCel} width={200}>
                <Typography variant="body2" className={classes.span}>
                  {row.label}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCel}>
                <Typography variant="body2">{row.value}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default memo(CookieDetailsTable)
